<template>
  <div id="appRoot">
    <template v-if="$route.meta.public == false">
      <v-app id="inspire" class="app">
        <app-drawer class="app--drawer"></app-drawer>
        <app-toolbar class="app--toolbar"></app-toolbar>
        <v-content>
          <!-- Page Header -->
          <page-header v-if="$route.meta.breadcrumb"></page-header>
          <div class="page-wrapper">
            <router-view></router-view>
          </div>
          <!-- App Footer -->
          <v-footer height="auto" class="white pa-3 app--footer">
            <span class="caption"
              >SIGAS-Gestion de Procesos SIMCE &copy;
              {{ new Date().getFullYear() }} {{ msg.version }}
            </span>
          </v-footer>
        </v-content>
        <!-- Go to top -->
        <app-fab></app-fab>
        <v-navigation-drawer
          class="setting-drawer"
          temporary
          right
          v-model="rightDrawer"
          hide-overlay
          fixed
        >
          <theme-settings></theme-settings>
        </v-navigation-drawer>
      </v-app>
    </template>
    <template v-if="$route.meta.public != false">
      <transition>
        <router-view :key="$route.fullPath"></router-view>
      </transition>
    </template>
    <FlashMessage></FlashMessage>
  </div>
</template>
<script>
import messages from "@/messages.json";
import jwtDecode from "jwt-decode";
import AppDrawer from "@/components/AppDrawer";
import AppToolbar from "@/components/AppToolbar";
import AppFab from "@/components/AppFab";
import PageHeader from "@/components/PageHeader";
import ThemeSettings from "@/components/ThemeSettings";
import AppEvents from "./event";
export default {
  components: {
    AppDrawer,
    AppToolbar,
    AppFab,
    PageHeader,
    ThemeSettings,
  },
  data: () => ({
    expanded: true,
    rightDrawer: false,
    msg: messages,
    snackbar: {
      show: false,
      text: "",
      color: "",
    },
    rutaPublic: "",
    rutaPath: "",
  }),

  computed: {
    isLoggedIn: function () {
      const token = localStorage.getItem("token");
      if (token) {
        return true;
      } else {
        return false;
      }
    },
  },

  created() {
  // Cargar eventos globales
  AppEvents.forEach((item) => {
    this.$on(item.name, item.callback);
  });
  window.getApp = this;

  const token = localStorage.getItem("token");
  if (token) {
    try {
      const decoded = jwtDecode(token); 
      const user = decoded.dto; 
      console.log("Usuario decodificado:", user);
      this.$store.commit("auth_success", {
        decoded
      });
    } catch (error) {
      console.error("Error decodificando el token:", error);
      this.$store.dispatch("logout"); 
    }
  }
},

  methods: {
    openThemeSettings() {
      this.$vuetify.goTo(0);
      this.rightDrawer = !this.rightDrawer;
    },
  },
};
</script>
<style lang="stylus" scoped>
.setting-fab
  top:50%!important;
  right:0;
  border-radius:0
.page-wrapper
  min-height:calc(100vh - 64px - 50px - 81px );
.primary--text
  color: #3f51b5 !important;
  caret-color: #3f51b5 !important;
</style>
